import {
	type MarketingBannerThemes,
	useMarketingBannerTextColor as useMarketingBannerTextColorShared
} from '@capsicum/features/feeds/shared';
import { useTheme } from 'styled-components';

type UseMarketingBannerTextColorProps = {
	theme: MarketingBannerThemes;
};

export const useMarketingBannerTextColor = ({ theme }: UseMarketingBannerTextColorProps) => {
	const {
		colors: {
			text: {
				main: { enabled, inverse }
			}
		}
	} = useTheme();

	return useMarketingBannerTextColorShared({ enabled, inverse, theme });
};
